import React, { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@zep-us/zus';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { getGetQuizSetBuildInfoQueryKey } from '@/api';
import { ErrorBoundaryFallback } from '@/components';
import { ErrorContent } from '@/components/ErrorBoundaryFallback';
import { GnbHeaderForGoogleClassroom } from '@/layout/Header/GnbHeaderForGoogleClassroom';
import { showMappedApiErrorDialog } from '@/shared/error/showMappedApiErrorDialog';
import { Conditional } from '@/shared/googleClassroom';
import { isAxiosNetworkOrTimeout } from '@/utils/isAxiosNetworkOrTimeout';
export const BuildPageErrorFallback = ({
  error,
  reset
}: {
  error: Error;
  reset: () => void;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const client = useQueryClient();
  const router = useRouter();
  const isNetworkError = isAxiosNetworkOrTimeout(error);
  useEffect(() => {
    if (isNetworkError) return;
    showMappedApiErrorDialog(error, {
      INVALID_USER_MEMBERTYPE: {
        title: t('common.error.unknown', {
          message: 'Unknown UserType'
        }),
        onConfirm: () => {
          void router.push('/sign-up/type').then(() => {
            void client.resetQueries({
              queryKey: getGetQuizSetBuildInfoQueryKey()
            });
          });
          reset?.();
        }
      }
    });
  }, [client, error, isNetworkError, reset, router, t]);
  if (isNetworkError) {
    return <>
        <Conditional inGoogleClassroom={<GnbHeaderForGoogleClassroom />} />
        <div className="flex w-full flex-col items-center gap-md pt-2xl">
          <ErrorContent />
          <span className="whitespace-pre-line text-center text-body-md-medium text-neutral">
            {t('error.network.unstableConnection')}
          </span>
          <Button className="mt-xs" size="lg" onClick={reset}>
            {t('common.error.reload')}
          </Button>
        </div>
      </>;
  }
  return <>
      <Conditional inGoogleClassroom={<GnbHeaderForGoogleClassroom />} data-sentry-element="Conditional" data-sentry-source-file="BuildPageErrorFallback.tsx">
        {/* <BuildHeader
          step="quiz"
          onStepChange={() => {}}
          isBuildPageBodyInView={true}
          isMapTemplateChangeLocked={false}
          onSubmitQuiz={() => {}}
          continueOnPersistButton={<></>}
         /> */}
      </Conditional>
      <div className={'pt-2xl'}>
        <ErrorBoundaryFallback error={error} data-sentry-element="ErrorBoundaryFallback" data-sentry-source-file="BuildPageErrorFallback.tsx" />
      </div>
    </>;
};